export enum BannerHeaderPositionId {
  FrontPage = 1,
  SearchResultPage = 2,
  AnnouncementDetailsPage = 3,
  CvBoxPage = 4,
}
